import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  LoyaltyConfig,
  RankBody,
  ResponseList,
  RewardHistoryBody,
  UserLoyaltyInfo,
  getActivityConfig,
  getAllRank,
  getDayRank,
  getRewardHistory,
  getUserLoyaltyInfo,
} from 'api/v1/loaylty'
import { uniqBy } from 'lodash'
import { RootState } from 'store'
import { RankType } from './types'

export const updateRankTypeAction = createAction<{ type: RankType }>(
  'loaylty/updateRankType'
)

export const getUserInfoAction = createAsyncThunk<
  UserLoyaltyInfo,
  { activityCode: string }
>('loaylty/getUserInfoAction', async ({ activityCode }) => {
  const { data } = await getUserLoyaltyInfo(activityCode)
  return data
})

export const getActivityConfigAction = createAsyncThunk<
  LoyaltyConfig,
  {
    activityCode: string
  }
>('loaylty/getActivityConfigAction', async ({ activityCode }) => {
  const { data } = await getActivityConfig(activityCode)
  return data
})

export const getAllRankAction = createAsyncThunk<
  ResponseList<RankBody[]>,
  {
    current: number
    size: number
  },
  {
    state: RootState
  }
>('loaylty/getAllRankAction', async ({ current, size }, { getState }) => {
  const { data } = await getAllRank(current, size)
  const state = getState()
  return {
    records: uniqBy([...state.loaylty.allRank.records, ...data.records], 'id'),
    total: data.total,
    size: data.size,
    current: data.current,
    pages: data.pages,
  }
})

export const getDayRankAction = createAsyncThunk<
  ResponseList<RankBody[]>,
  {
    current: number
    size: number
  },
  {
    state: RootState
  }
>('loaylty/getDayRankAction', async ({ current, size }, { getState }) => {
  const { data } = await getDayRank(current, size)
  const state = getState()
  return {
    records: uniqBy([...state.loaylty.dayRank.records, ...data.records], 'id'),
    total: data.total,
    size: data.size,
    current: data.current,
    pages: data.pages,
  }
})

export const getRewardHistoryAction = createAsyncThunk<
  ResponseList<RewardHistoryBody[]>,
  {
    current: number
    size: number
    activityCode?: string
  },
  {
    state: RootState
  }
>(
  'loaylty/getRewardHistoryAction',
  async ({ current, size, activityCode = 'points' }, { getState }) => {
    const { data } = await getRewardHistory(current, size, activityCode)
    const state = getState()
    return {
      records: uniqBy(
        [...state.loaylty.rewardHistory.records, ...data.records],
        'id'
      ),
      total: data.total,
      size: data.size,
      current: data.current,
      pages: data.pages,
    }
  }
)
